module.exports = __webpack_public_path__ + "img/pizza-1.19d8f19d.jpg";